import { useMutation } from 'react-query';
import axios from 'axios';

/**
 * Hook to complete the onboarding tour
 */
export const useMutationCompleteTour = (token, onSuccess, onError) => {

  return useMutation(
    async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/complete-tour`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        // Don't invalidate profile query here - let the caller handle it
        // to avoid duplicate API calls
        if (onSuccess) onSuccess(data);
      },
      onError: (error) => {
        console.error('Error completing tour:', error);
        if (onError) onError(error);
      },
    }
  );
};

